import { coin_list } from "./CoinList";
import { coin_info } from "./CoinInfo";
import { coin_price } from "./CoinPrice";
import { cwallet_user } from "./CwalletUser";
import { coin_withdraw_fee_list } from "./CoinWithdrawFeeList";
import { fait_list } from "./FaitList";

export const codeMap: { [key: string]: any } = {
  coin_list,
  coin_info,
  coin_price,
  cwallet_user,
  coin_withdraw_fee_list,
  fait_list,
};
